import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const PasswordValidator = (): ValidatorFn => {
    return (control: AbstractControl): ValidationErrors | null => {
        var withUpperLowerCase: boolean = control.value.match(/.*[a-z].*/g) != null && control.value.match(/.*[A-Z].*/g) != null;
        var withNumberAndSymbol: boolean = control.value.match(/[^0-9A-Za-z]/g) != null && control.value.match(/.*\d.*/g) != null;
        var lengthCorrect: boolean = control.value.length >= 8 && control.value.length <= 20;
        return (withUpperLowerCase && withNumberAndSymbol && lengthCorrect) || !control.value ? null : {error: true};
    };
}